import axios from "axios";
import { registerInterceptors } from "../interceptors/register";
import type { MobileCheckoutEnvironment } from "../../shared/lib/environment";

/**
 * A kiosk runs unattended for days, so a request that never settles is worse
 * than one that fails. RTK Query keeps a pending cache entry forever, drops
 * every later poll while it is pending, and reports no error, which freezes the
 * UI on stale data with nothing for the recovery paths to react to. Failing
 * fast turns that silent freeze into a normal failure. No instance here carries
 * a long-lived transport: the scan stream is sse.js, not axios.
 */
export const REQUEST_TIMEOUT_MS = 15_000;

const apiInstances = {
  gatewayApiInstance: axios.create({
    baseURL: import.meta.env.VITE_GATEWAY_API_URL,
    timeout: REQUEST_TIMEOUT_MS,
  }),
  hitlApiInstance: axios.create({ timeout: REQUEST_TIMEOUT_MS }),
  posApiInstance: axios.create({ timeout: REQUEST_TIMEOUT_MS }),
  zoneApiInstance: axios.create({ timeout: REQUEST_TIMEOUT_MS }),
  sdpApiInstance: axios.create({ timeout: REQUEST_TIMEOUT_MS }),
  cartApiInstance: axios.create({ timeout: REQUEST_TIMEOUT_MS }),
};

export const {
  gatewayApiInstance,
  hitlApiInstance,
  zoneApiInstance,
  posApiInstance,
  sdpApiInstance,
  cartApiInstance,
} = apiInstances;

export const updateGlobalAPIBaseURLs = (
  environment: MobileCheckoutEnvironment,
  storeKey?: string,
) => {
  posApiInstance.defaults.baseURL = environment["rms-mapper"];
  zoneApiInstance.defaults.baseURL = environment["zone"];
  hitlApiInstance.defaults.baseURL = environment["sib"];
  sdpApiInstance.defaults.baseURL = environment["sdp"];
  cartApiInstance.defaults.baseURL = environment["rms-mapper"] + "/cart";

  if (storeKey) {
    [posApiInstance, zoneApiInstance, hitlApiInstance, sdpApiInstance, cartApiInstance]
      .forEach((instance) => {
        instance.defaults.authRecovery = {
          storeKey,
          reason: "http-401",
        };
      });
  }
};

registerInterceptors(apiInstances);
